<div class="column custom-form__block" :class="columnWidthClass" v-html="field.contentHtml"></div>
